const rfm_entities = [
    "proposal",
    "material_request",
    "fee_estimate",
    "contract",
    "qualification",
    "service_request"
]

const requests_for_material_utilities = {
    methods: {
        is_revisionable_rfm_entity (entity) {
            return entity.match(/^(proposal|fee_estimate|contract|service_request)$/i)
        },
        revision_entity_for_rfm_entity (entity) {
            if(this.is_revisionable_rfm_entity(entity)) return `${entity}_revision`
            return ""
        },
        status_for_rfm (rfm) {
            if(rfm) {
                if(rfm.accepted_at) return "Accepted"
                if(rfm.rejected_at) return "Rejected"
                if(rfm.sent_at) return "Sent"
            }
            return "(Not Sent)"
        }
    },
    data () {
        return {
            rfm_entities
        }
    }
}

export default requests_for_material_utilities
